import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 180000, // 3 min — generate-design retries up to 3x × ~30-60s
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aiat_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const generateDesign = (payload) => api.post("/generate-design", payload).then((r) => r.data);
export const analyzeMaterials = (payload) => api.post("/analyze-materials", payload).then((r) => r.data);
export const submitConsultation = (payload) => api.post("/consultations", payload).then((r) => r.data);
export const getPaymentInfo = () => api.get("/payment-info").then((r) => r.data);
export const createPayment = (payload) => api.post("/payments", payload).then((r) => r.data);
export const submitReceipt = (id) => api.post(`/payments/${id}/submit-receipt`).then((r) => r.data);
export const confirmPayment = (id) => api.post(`/payments/${id}/confirm`).then((r) => r.data);
export const getPayment = (id) => api.get(`/payments/${id}`).then((r) => r.data);

// Admin
export const adminLogin = (payload) => api.post("/admin/login", payload).then((r) => r.data);
export const adminMe = () => api.get("/admin/me").then((r) => r.data);
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminConsultations = () => api.get("/consultations").then((r) => r.data);
export const adminPayments = () => api.get("/admin/payments").then((r) => r.data);
export const adminDeleteConsultation = (id) => api.delete(`/admin/consultations/${id}`).then((r) => r.data);
export const adminDeletePayment = (id) => api.delete(`/admin/payments/${id}`).then((r) => r.data);
export const adminExportUrl = () => `${API}/admin/export.xlsx`;
